<template>

<li v-if="hasOptions" class="filter">

    <a v-b-toggle="'filter-' + name.toLowerCase()" >
        <label>{{ label }}</label>
        <span class="roll-button right">
            <i class="up far fa-angle-up d-none"></i>
            <i class="down far fa-angle-down"></i>
        </span>
    </a>


    <b-collapse tag="ul" :id="'filter-' + name.toLowerCase()" class="filter-option-list" :visible='open'>
        <li v-for="option in filter.options" :key="option.id" v-show="option.active" class="filter-option">

            <label :for="optionId(option)"> {{ option.name }} </label>
            <!-- :class="{disabled: !option.active}" -->

            <input
                :id="optionId(option)"
                :name="inputName"
                :value="option.id"
                type="checkbox"
                :checked="option.on"
                @input="$emit('filter-change', filterName, option.id, $event.target.checked)"
            />
            <!-- :disabled="!option.active" -->

        </li>
    </b-collapse>
</li>
</template>

<script>

    export default {

        props: {
            name: String,
            filter: Object,
            open: {
                type: Boolean,
                default: false,
            }
        },

        computed: {

            label: function() {
                return _.capitalize(this.name);
            },

            filterName: function() {
                return _.kebabCase(this.name);
            },

            inputName: function() {
                return this.filterName + '[]';
            },

            hasOptions: function() {
                return this.filter.options.reduce((a, b) => a || b.active, false);
            }

        },

        methods: {
            optionId: function(opt) {
                let id = 'id_' + this.filterName + '_' + opt.id;
                return id.toLowerCase();
            }
        }
    }

</script>
